import React, { useContext, useEffect, useState, memo } from "react";

import { FormControlLabel, Grid, Grow, Switch } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import Select from "../../../../components/basics/SelectErp";
import { Margin, MinHeight } from "../styles/Emissao";

import useCalculosTributacao from "../controllers/RulesEmissaoCalculosTributacao";
import { AplicaveisBc, SearchRulesTaxation } from "./RulesEmissaoTributacao";
import RenderTaxationFields from "./RenderTaxationFields";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { EmissaoContext } from "../contexts/EmissaoContext";
import useEmissaoController from "../controllers/EmissaoController";
import { GlobalVariables } from "../../../../GlobalVariables";

const TabEmissaoICMS = ({ ...props }) => {
  const {
    productError,
    productIcmsSource,
    setProductIcmsSource,
    productIcmsSituation,
    setProductIcmsSituation,
    productIcmsListNormalTaxationSituation,
    productIcmsListSimpleTaxationSituation,
    productIcmsListSource,
    productCheckIcmsFreight,
    setProductCheckIcmsFreight,
    productCheckIcmsSafe,
    setProductCheckIcmsSafe,
    productCheckIcmsDifal,
    setProductCheckIcmsDifal,
    productCheckIcmsOthers,
    setProductCheckIcmsOthers,
    productCheckIcmsDiscount,
    setProductCheckIcmsDiscount,
    productDataNcm,
    productDataId,
    productDataCfop,
  } = useContext(ParametrosProdutoContext);

  const { queryParams } = useContext(QueryParamsContext);

  const {
    visualizationOnly,
    nfeMontageSubtype,
    senderIndicationIe,
    headerFinnally,
  } = useContext(EmissaoContext);

  const [rulesTaxation, setRulesTaxation] = useState(null);
  const { handleNcm } = useEmissaoController();
  const {
    handleCalcBCIcms,
    handleCalcBcIcmsSt,
    handleCalcIcms,
    handleCalcIcmsSt,
    handleFcpIcms,
    handleFcpIcmsSt,
    handleCreditIcms,
    handleFcpIcmsDi,
    handleCalcIcmsInterstate,
  } = useCalculosTributacao();

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    if (headerFinnally.value !== GlobalVariables.nfe.purpose.additionalNfe)
      handleCalcIcmsSt();
  }, [handleCalcIcmsSt, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    if (headerFinnally.value !== GlobalVariables.nfe.purpose.additionalNfe)
      handleCalcIcms();
  }, [handleCalcIcms, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcBcIcmsSt();
  }, [handleCalcBcIcmsSt, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcBCIcms();
  }, [handleCalcBCIcms, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") {
      handleFcpIcmsDi();
      return;
    }
    handleFcpIcms();
  }, [handleFcpIcms, handleFcpIcmsDi, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleFcpIcmsSt();
  }, [handleFcpIcmsSt, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCreditIcms();
  }, [handleCreditIcms, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcIcmsInterstate();
  }, [handleCalcIcmsInterstate, nfeMontageSubtype]);

  useEffect(() => {
    setRulesTaxation(
      productIcmsSituation
        ? SearchRulesTaxation(productIcmsSituation.value)
        : null
    );
  }, [setRulesTaxation, productIcmsSituation]);

  return (
    <Grid container spacing={2}>
      {AplicaveisBc({
        frete: productCheckIcmsFreight,
        setFrete: setProductCheckIcmsFreight,
        seguro: productCheckIcmsSafe,
        setSeguro: setProductCheckIcmsSafe,
        desconto: productCheckIcmsDiscount,
        setDesconto: setProductCheckIcmsDiscount,
        outras: productCheckIcmsOthers,
        setOutras: setProductCheckIcmsOthers,
      })}
      <Grow in={true}>
        <Grid item sm={6}>
          <Card line="left" label="ICMS">
            <Margin top="10">
              <MinHeight minHeight="45">
                <Grid container spacing={2}>
                  <Grid item lg={12} sm={12}>
                    <Select
                      optionsList={productIcmsListSource}
                      descriptionField="label"
                      label="Origem"
                      value={productIcmsSource}
                      setValue={setProductIcmsSource}
                      variant="filled"
                      disabled={visualizationOnly}
                    />
                  </Grid>
                  <Grid item lg={12} sm={12}>
                    <Select
                      optionsList={
                        queryParams.crt === "1" || queryParams.crt === "4"
                          ? productIcmsListSimpleTaxationSituation
                          : productIcmsListNormalTaxationSituation
                      }
                      descriptionField="label"
                      label="Situação Tributária ICMS"
                      value={productIcmsSituation}
                      setValue={setProductIcmsSituation}
                      error={productError.productIcmsSituation ? true : false}
                      helperText={productError.productIcmsSituation || ""}
                      variant="filled"
                      disabled={visualizationOnly}
                    />
                  </Grid>
                  {rulesTaxation && (
                    <RenderTaxationFields
                      rulesTaxation={rulesTaxation}
                      type="ICMS"
                      visualizationOnly={visualizationOnly}
                    />
                  )}
                  {productIcmsSituation &&
                    [6].includes(
                      parseInt(
                        (productDataCfop?.cfop || "").toString().charAt(0)
                      )
                    ) &&
                    senderIndicationIe?.codigo === "9" && (
                      <Grid item lg={6} sm={12}>
                        <FormControlLabel
                          label="DIFAL - UF ENTREGA"
                          value="end"
                          control={
                            <Switch
                              disabled={visualizationOnly}
                              checked={productCheckIcmsDifal}
                              onChange={(input, value) => {
                                setProductCheckIcmsDifal((current) => !current);
                                handleNcm({
                                  ncm: productDataNcm,
                                  productId: productDataId,
                                  difalChecked: value,
                                });
                              }}
                              color="primary"
                            />
                          }
                        />
                      </Grid>
                    )}
                </Grid>
              </MinHeight>
            </Margin>
          </Card>
        </Grid>
      </Grow>
      <Grow in={true} {...(true ? { timeout: 800 } : {})}>
        <Grid item sm={6}>
          <Card line="left" label="ICMS ST">
            <Margin top="10">
              <MinHeight minHeight="45">
                <Grid container spacing={2}>
                  {rulesTaxation && (
                    <RenderTaxationFields
                      rulesTaxation={rulesTaxation}
                      type="ST"
                      visualizationOnly={visualizationOnly}
                    />
                  )}
                </Grid>
              </MinHeight>
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default memo(TabEmissaoICMS);
